import { useEffect, useState } from 'react';
import DirectInput from '../../components/directInput/DirectInput';
import Textarea from '../../components/textarea/Textarea';
import './blogUpload.css';
import Tags from '../../components/tags/Tags';
import blogSubmit from './blogUploadFun/blogSubmit';
import { toast } from 'react-toastify';
import ReactLoading from 'react-loading';
import { useNavigate, useParams } from 'react-router-dom';
import AddIcon from '../../assets/icons/trvto_add_icon.svg';
import RemoveIcon from '../../assets/icons/trvto_remove_icon.svg';
import fetchBlogDetailData from '../blogDeatils/fetchBlogDataFun/fetchBlogData';
import BackIcon from '../../assets/icons/trvto_ArrowBack.svg';
import CharCount from '../../components/charCount/CharCount';
import { modules } from '../../utils/quillModules';
import { formats } from '../../utils/quillFormats';
import handleChange from '../../utils/handleChange';
import ReactQuill from 'react-quill';

export default function BlogUpload() {
    const { id } = useParams();
    const navigate = useNavigate();
    const userId = window.localStorage.userId;
    const [loading, setLoading] = useState(false);
    const [blog, setBlog] = useState({
        _id: '',
        name: '',
        shortDescription: '',
        description: [
            {
                title: '',
                description: [''],
                oldImage: null,
                newImage: null
            }
        ],
        oldImage: null,
        newImage: null,
        tags: [],
        author: '',
        imageRefId: ''
    });

    useEffect(() => {
        if (!id) return;
        fetchBlogDetailData(id, setBlog, setLoading);
    }, [id]);

    function handleBlogImage(e) {
        if (e.target.files[0]) {
            if (e.target.files[0].size > 20e6) {
                toast.error('Image size should be less than 5Mb');
                return;
            }
            setBlog({ ...blog, newImage: e.target.files[0] });
        }
    }

    function addSection() {
        setBlog((prev) => ({
            ...prev,
            description: [...prev.description, { title: '', description: [''], image: null }]
        }));
    }

    function removeSection() {
        setBlog((prev) => ({
            ...prev,
            description: prev.description.slice(0, -1)
        }));
    }

    function updateSection(index, key, value) {
        const updatedSections = [...blog.description];
        updatedSections[index][key] = value;
        setBlog({ ...blog, description: updatedSections });
    }

    function updateParagraph(index, paragraphIndex, value) {
        const updatedSections = [...blog.description];
        updatedSections[index].description[paragraphIndex] = value;
        setBlog({ ...blog, description: updatedSections });
    }

    function addParagraph(index) {
        const updatedSections = [...blog.description];
        updatedSections[index].description.push('');
        setBlog({ ...blog, description: updatedSections });
    }

    const removeParagraph = (parentIndex, index) => {
        const updatedSections = [...blog.description];
        updatedSections[parentIndex].description = updatedSections[parentIndex].description.filter(
            (_, i) => i !== index
        );
        setBlog({ ...blog, description: updatedSections });
    };

    const handleBlogSubmit = async () => {
        const res = await blogSubmit(blog, userId, setLoading);
        if (res === 200) {
            navigate(-1);
        }
    };

    return (
        <>
            <button className='backBtn' onClick={() => navigate(-1)}>
                <img src={BackIcon} alt='back' />
                Back to Blogs
            </button>
            <div className='blogUploadDiv'>
                <h1 className='blogUpHead'>Blog Upload</h1>
                <div>
                    <div className='inputCharDiv'>
                        <DirectInput
                            label='Name'
                            name='name'
                            value={blog.name}
                            type='text'
                            placeholder='Enter the name of the blog'
                            setFormData={setBlog}
                            min={10}
                            limit={60}
                        />
                    </div>
                    <div className='inputCharDiv'>
                        <label className='textareaLabel'>Short Description</label>
                        <ReactQuill
                            name='shortDescription'
                            value={blog.shortDescription}
                            onChange={(value) => handleChange({ target: { name: 'shortDescription', value } }, setBlog)}
                            theme='snow'
                            placeholder='add short description'
                            // className='itineraryInput textArea'
                            modules={modules}
                            formats={formats}
                        />
                    </div>
                    <div className='flex itineraryInDiv blogImgContainer'>
                        <label className='directInLabel'>Image</label>
                        <div className='blogImageDive'>
                            <input type='file' accept='.png, .jpeg, .jpg' onChange={(e) => handleBlogImage(e)} />
                        </div>
                    </div>
                    {blog.oldImage || blog.newImage ? (
                        <div className='imgDisplayDiv'>
                            {(() => {
                                const imageData = blog.newImage ? blog.newImage : blog.oldImage;
                                // To display the image convert it to URL
                                const fileURL =
                                    typeof imageData === 'string' ? imageData : URL.createObjectURL(imageData);

                                return (
                                    <img
                                        src={fileURL}
                                        alt='trvto_blog'
                                        className='wallImgDisp'
                                        loading='lazy'
                                        decoding='async'
                                    />
                                );
                            })()}
                        </div>
                    ) : null}

                    {/* Sections */}
                    {blog.description.map((section, index) => (
                        <div className='inputCharDiv' key={index}>
                            <p className='sectionHeader'>{`Section ${index + 1}`}</p>
                            <div>
                                <label className='directInLabel'>Sub Header</label>
                                <div className='directInInputDiv fullWidth'>
                                    <input
                                        className='directInInput fullWidth'
                                        type='text'
                                        name={`subHeader_${index}`}
                                        value={section.title}
                                        placeholder='Enter the sub header'
                                        onChange={(e) => updateSection(index, 'title', e.target.value)}
                                    />
                                    <CharCount string={section.title ? section.title : ''} min={10} limit={50} />
                                </div>
                            </div>
                            <div className='flex itineraryInDiv'>
                                <label className='directInLabel'>Section Image</label>
                                <div className='blogImageDive'>
                                    <input
                                        type='file'
                                        accept='.png, .jpeg, .jpg'
                                        onChange={(e) => updateSection(index, 'newImage', e.target.files[0])}
                                    />
                                </div>
                            </div>
                            {section.oldImage || section.newImage ? (
                                <div className='imgDisplayDiv'>
                                    {(() => {
                                        const imageData = section.newImage ? section.newImage : section.oldImage;
                                        // To display the image convert it to URL
                                        const fileURL =
                                            typeof imageData === 'string' ? imageData : URL.createObjectURL(imageData);

                                        return (
                                            <img
                                                src={fileURL}
                                                alt='trvto_blog_section'
                                                className='wallImgDisp'
                                                loading='lazy'
                                                decoding='async'
                                            />
                                        );
                                    })()}
                                </div>
                            ) : null}
                            {section.description.map((paragraph, paragraphIndex) => (
                                <div key={paragraphIndex}>
                                    <label className='directInLabel blogLable'>Paragraph {paragraphIndex + 1}</label>

                                    <ReactQuill
                                        name={`description_${index}_${paragraphIndex}`}
                                        value={paragraph}
                                        onChange={(value) => updateParagraph(index, paragraphIndex, value)}
                                        theme='snow'
                                        placeholder='Enter the paragraph'
                                        className=' fullWidth textArea'
                                        modules={modules}
                                        formats={formats}
                                    />
                                    <CharCount string={paragraph ? paragraph : ''} min={50} limit={5000} />

                                    {paragraphIndex === section?.description?.length - 1 && (
                                        <button
                                            type='button'
                                            onClick={() => addParagraph(index)}
                                            className='blogActionBtn blueBtn'
                                        >
                                            <img src={AddIcon} alt='add' width={32} height={32} />
                                        </button>
                                    )}
                                    <button
                                        type='button'
                                        onClick={() => removeParagraph(index, paragraphIndex)}
                                        className='blogActionBtn'
                                    >
                                        <img src={RemoveIcon} alt='remove' width={32} height={32} />
                                    </button>
                                </div>
                            ))}
                        </div>
                    ))}

                    <div className='flex'>
                        <button type='button' className='nestedTagOkBtn blueBtn' onClick={addSection}>
                            Add Section
                        </button>
                        {blog.description.length > 1 && (
                            <button type='button' className='nestedTagOkBtn removeSecBtn' onClick={removeSection}>
                                Remove Section
                            </button>
                        )}
                    </div>

                    <Tags data={blog} setData={setBlog} />
                </div>
                <div className='btnContainer'>
                    <button type='button' className='submitBtn blueBtn' onClick={handleBlogSubmit}>
                        Save
                    </button>
                </div>
                {loading && (
                    <div className='loadingBackground'>
                        <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                    </div>
                )}
            </div>
        </>
    );
}
